var map = {
	"./1-2.png": "c18b",
	"./2-2.png": "61a7",
	"./3-2.png": "5002",
	"./4-2.png": "e5ad",
	"./5-2.png": "c35f",
	"./6-2.png": "d29d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a76a";